import { useEffect, useState } from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import { useLocation } from 'react-router-dom';
import { FormatTime, FormatTimeDate, LocalFormat, decodeID, getLastURL, sidebarOpen } from '../../../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';
import { StaffMemberDetailAction, StaffMemberViewDetailAction } from '../../../../redux/Action/StaffMemberAction';
import Spinner from '../../../../components/Spinner';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

const StaffMemberDetails = () => {
    const staff_member_detail: any = useSelector((state: any) => state.StaffMemberViewDetailState)
    const [staffMember, setStaffMember]: any = useState([])

    moment.locale('en');



    const breadcrumbItems = [
        { title: 'dashboard', link: '/dashboard' },
        { title: 'Staff_Member_List', link: '/staff-member' },
        { title: 'View_staff_member' }
    ];

    const location = useLocation();
    const viewId = getLastURL(location);
    const dispatch = useDispatch<any>();

    const params = { staff_id: decodeID(viewId) };


    useEffect(() => {
        // dispatch(StaffMemberDetailAction(params))
        dispatch(StaffMemberViewDetailAction(params))
    }, [])

    useEffect(() => {
        if (staff_member_detail?.status) {
            setStaffMember(staff_member_detail?.data?.data?.data)
        }
    }, [staff_member_detail])


 

    return (
        <>
            <div className='col-lg-9 serviceManagement'>
                {staff_member_detail?.loading ? <Spinner /> : ""}
                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2><button onClick={() => { sidebarOpen() }} type='button' className='btn mobileMenu p-1 d-lg-none'><span className="icon-menu-right"></span></button>  <FormattedMessage id="staff_member" /></h2>
                        <Breadcrumb items={breadcrumbItems} />
                    </div>
                    <div className='dashboarcard'>
                        <div className='userTOP'>
                            <figure><img src={staff_member_detail?.data?.data?.data?.profile_pic ? staff_member_detail?.data?.data?.data?.profile_pic : "images/USER_NEW.png    "} onError={(e: any) => e.target.src = "images/fely-beauty.jpg"} /></figure>
                            <div className='userTOPDetails'>
                                <h6>{staffMember?.owner_name ? staffMember?.owner_name : "N/A"}</h6>

                                <div className="aboutContact"><span><i className="icon-call"></i>{staffMember?.phone_country_code + " " + staffMember?.phone_number}</span>
                                    <span><i className="icon-email"></i>{staffMember?.email ? staffMember?.email : "N/A"}</span>
                                </div>

                                <div className="aboutLocation"><span><i className="icon-location"></i> {staffMember?.location + (staffMember?.country ? ", " + staffMember?.country : "")}</span></div>
                                <div className="userAction mt-3 gap-1">
                                    {/* <button type="button" className="btn btnroundIcon"><i className="icon-edit"></i></button><button type="button" className="btn btnroundIcon mx-1 mx-sm-2"><i className="icon-delete"></i></button> */}
                                    {/* <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" /></div> */}
                                </div>
                            </div>
                        </div>
                        {/* <div className='totalNumberService my-4'>
                            Total Number of Services Catered : <span>{staff_member_detail?.data?.data?.staffTotalAddservices ? staff_member_detail?.data?.data?.staffTotalAddservices : 0}</span>
                            <i className="icon-angel-down ms-auto"></i>
                        </div> */}
                        <div className='dashCard p-0'>
                            <div className='row row-cols-2 row-cols-sm-3 row-cols-lg-6 g-3 align-itmes-stretch'>
                                <div className='col'>
                                    <div className='D_card color1'>
                                        <p className='topNumber'>{staff_member_detail?.data?.data?.TotalCompletedServices ? staff_member_detail?.data?.data?.TotalCompletedServices : "0"}</p>
                                        <p><FormattedMessage id="Completed" /> <br /><FormattedMessage id="services" /></p>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='D_card color2'>
                                        <p className='topNumber'>{staff_member_detail?.data?.data?.TotalUpcomingServices ? staff_member_detail?.data?.data?.TotalUpcomingServices : "0"}</p>
                                        <p><FormattedMessage id="Upcoming" /> <br /><FormattedMessage id="services" /></p>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='D_card color3'>
                                        <p className='topNumber'>{staff_member_detail?.data?.data?.TotalCancelledServices ? staff_member_detail?.data?.data?.TotalCancelledServices : "0"}</p>
                                        <p><FormattedMessage id="Cancelled" /> <br /><FormattedMessage id="services" /></p>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='D_card color4'>
                                        <p className='topNumber'>{staff_member_detail?.data?.data?.TotalShownUpServices ? staff_member_detail?.data?.data?.TotalShownUpServices : "0"}</p>
                                        <p><FormattedMessage id="No_Shown_upon" /> <br /><FormattedMessage id="services" /></p>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='D_card color5'>
                                        <p className='topNumber'>{staff_member_detail?.data?.data?.TotalOnlineServices ? staff_member_detail?.data?.data?.TotalOnlineServices : "0"}</p>
                                        <p><FormattedMessage id="online" /> <br /><FormattedMessage id="Bookings" /></p>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='D_card color6'>
                                        <p className='topNumber'>{staff_member_detail?.data?.data?.TotalofflineServices ? staff_member_detail?.data?.data?.TotalofflineServices : "0"}</p>
                                        <p><FormattedMessage id="offline" /> <br /><FormattedMessage id="services" /></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='row gx-lg-5 gy-3 mt-4'>
                            <div className='col-md-5 staffWorkHour'>
                                <h6>Available Operational Days and Operational Hours.</h6>
                                <ul className='mt-4'>
                                    {
                                        staff_member_detail?.data?.data?.staff_opt_days?.map((item: any) => {
                                            const formattedTime = item?.start_time ? moment.utc(item.start_time, 'HH:mm').local().format('hh:mm A') : '';
                                            const endTime = item?.start_time ? moment.utc(item.end_time, 'HH:mm').local().format('hh:mm A') : '';
                                            return (
                                                item?.start_time != '00:00:00' && item?.end_time != '00:00:00' && <li>{item?.day} <span>{formattedTime}  to {endTime}</span></li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <div className='col-md-7 blockedDate'>
                                <h6>Services</h6>
                                <div className='d-flex gap-2 flex-wrap staff-services-row'>
                                    {
                                        staff_member_detail?.data?.data?.data?.service_detail?.length > 0 && staff_member_detail?.data?.data?.data?.service_detail?.map((item: any) => {
                                            return (
                                                <>
                                                    {
                                                        item?.services_details?.[0]?.name && <div className='sgl-s-ser badge'>{item?.services_details?.[0]?.name}</div>
                                                    }
                                                </>
                                            )
                                        }
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StaffMemberDetails